import React from 'react';
import {
  Header, Icon, Segment,
} from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';

const ValidateDataResultsNotRun = () => (
  <Segment attached="bottom" placeholder className="aridhia-validate-data-results-not-run">
    <Header icon>
      <Icon name="question circle" className="primary" />
      <FormattedMessage id="dataset.data.placeholder.title" />
    </Header>
  </Segment>
);

export default ValidateDataResultsNotRun;
